import { provideSignalFormsConfig } from '@angular/forms/signals';
import { NG_STATUS_CLASSES } from '@angular/forms/signals/compat';

/**
 * Task 35861: signal forms add no ng-valid / ng-invalid / ng-touched / ng-dirty classes by default. The reactive and
 * template-driven controls they replace had them, and the Kendo theme keys its red invalid border on them
 * (.k-input-solid.ng-invalid.ng-touched / .ng-dirty), so a converted required field loses its marker. Every web app
 * whose forms are being converted provides this in its AppModule (conventions.md signal forms checklist item 14).
 * Apps built on signal forms from the start (Project Hub, Ryn's Roost, Ryn Control Center) never had the classes and
 * do not provide it.
 */
export const UPS_SIGNAL_FORMS_CONFIG = provideSignalFormsConfig({
  classes: NG_STATUS_CLASSES,
});
